/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Workout_After_End_TitleInputs */

const en_us2_workout_after_end_title = /** @type {(inputs: Workout_After_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`End with ${i?.done} of 1 set?`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`End with ${i?.done} of 1 set?`);
	return /** @type {LocalizedString} */ (`End with ${i?.done} of ${i?.total} sets?`)
	
};

const pt_br2_workout_after_end_title = /** @type {(inputs: Workout_After_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Encerrar com ${i?.done} de 1 série?`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`Encerrar com ${i?.done} de 1 série?`);
	return /** @type {LocalizedString} */ (`Encerrar com ${i?.done} de ${i?.total} séries?`)
	
};

const es_419_workout_after_end_title = /** @type {(inputs: Workout_After_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`¿Terminar con ${i?.done} de 1 serie?`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`¿Terminar con ${i?.done} de 1 serie?`);
	return /** @type {LocalizedString} */ (`¿Terminar con ${i?.done} de ${i?.total} series?`)
	
};

const pt_pt2_workout_after_end_title = /** @type {(inputs: Workout_After_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Terminar com ${i?.done} de 1 série?`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`Terminar com ${i?.done} de 1 série?`);
	return /** @type {LocalizedString} */ (`Terminar com ${i?.done} de ${i?.total} séries?`)
	
};

const fr_fr2_workout_after_end_title = /** @type {(inputs: Workout_After_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Terminer avec ${i?.done} série sur 1 ?`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`Terminer avec ${i?.done} série sur 1 ?`);
	return /** @type {LocalizedString} */ (`Terminer avec ${i?.done} séries sur ${i?.total} ?`)
	
};

const de_de2_workout_after_end_title = /** @type {(inputs: Workout_After_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Mit ${i?.done} von 1 Satz beenden?`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`Mit ${i?.done} von 1 Satz beenden?`);
	return /** @type {LocalizedString} */ (`Mit ${i?.done} von ${i?.total} Sätzen beenden?`)
	
};

const it_it2_workout_after_end_title = /** @type {(inputs: Workout_After_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Terminare con ${i?.done} di 1 serie?`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`Terminare con ${i?.done} di 1 serie?`);
	return /** @type {LocalizedString} */ (`Terminare con ${i?.done} di ${i?.total} serie?`)
	
};

/**
* | total | output |
* | --- | --- |
* | "1" | "End with {done} of 1 set?" |
* | "-1" | "End with {done} of 1 set?" |
* | * | "End with {done} of {total} sets?" |
*
* @param {Workout_After_End_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_end_title = /** @type {((inputs: Workout_After_End_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_End_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_end_title(inputs)
	if (locale === "es-419") return es_419_workout_after_end_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_end_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_end_title(inputs)
	if (locale === "de-DE") return de_de2_workout_after_end_title(inputs)
	if (locale === "it-IT") return it_it2_workout_after_end_title(inputs)
	return en_us2_workout_after_end_title(inputs)
});
export { workout_after_end_title as "workout-after.end_title" }